import { id, i, init } from '@instantdb/react';

// Initialize InstantDB with proper schema
const APP_ID = '45d4f1fc-1bcb-40c3-9388-5d4f4447aed6';

// Define schema according to docs
const schema = i.schema({
  entities: {
    users: i.entity({
      email: i.string(),
      name: i.string(),
    }),
    projects: i.entity({
      name: i.string(),
      description: i.string(),
      created_by: i.string(),
      created_at: i.string(),
      updated_at: i.string(),
    }),
    project_members: i.entity({
      project_id: i.string(),
      user_id: i.string(),
      role: i.string(),
      joined_at: i.string(),
    }),
    tasks: i.entity({
      project_id: i.string().optional(), // Make project_id optional for personal tasks
      title: i.string(),
      description: i.string(),
      created_by: i.string(),
      assigned_to: i.string().optional(),
      status: i.string(),
      priority: i.string(),
      due_date: i.string().optional(),
      tags: i.string().optional(),
      created_at: i.string(),
      updated_at: i.string(),
      completed_at: i.string().optional(),
      time_spent: i.string().optional(), // Total time in seconds
      is_timer_running: i.string().optional(), // "true" if timer is active
      timer_started_at: i.string().optional(), // When current session started
    }),
    invitations: i.entity({
      project_id: i.string(),
      invited_email: i.string(),
      invited_by: i.string(),
      role: i.string(),
      status: i.string(), // 'pending', 'accepted', 'declined'
      created_at: i.string(),
      expires_at: i.string(),
    }),
    task_activities: i.entity({
      task_id: i.string(),
      user_id: i.string(),
      action: i.string(), // 'created', 'updated', 'status_changed', 'timer_started', 'timer_stopped', 'comment_added'
      description: i.string(),
      old_value: i.string().optional(),
      new_value: i.string().optional(),
      created_at: i.string(),
    }),
  },
});

console.log('Initializing InstantDB with APP_ID:', APP_ID);

const db = init({ 
  appId: APP_ID,
  schema,
});

console.log('InstantDB initialized successfully');

// Export the id helper for creating new entities
export { id };
export default db;